<template>
    <div id="qg-modal">
        <cancel-task-modal></cancel-task-modal>
        <cancel-confirm-task-modal></cancel-confirm-task-modal>
    </div>
</template>

<script>
import CancelTaskModal from './../../../qaamgo/modules/sat/components/result_v2/components/Modal/CancelTaskModal';
import CancelConfirmTaskModal from './../../../qaamgo/modules/sat/components/result_v2/components/Modal/CancelConfirmTaskModal';

export default {
    name: 'Modals',
    components: {
        CancelTaskModal,
        CancelConfirmTaskModal
    },
    created() {},
    methods: {},
    computed: {},
    data() {
        return {};
    },
};
</script>
